import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/apiService";

export const GetOnePalestinianGovernoratesProjectActivities = createAsyncThunk(
  "OnePalestinianGovernoratesProjectActivities/OneGetPalestinianGovernoratesProjectActivities",
  async (
    tG_PalestinianGovernoratesProjectActivitiesId,
    { rejectWithValue }
  ) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TG_PalestinianGovernoratesProjectActivities/GetTG_PalestinianGovernoratesProjectActivitiesData",
        {
          tG_PalestinianGovernoratesProjectActivitiesId:
            tG_PalestinianGovernoratesProjectActivitiesId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateOnePalestinianGovernoratesProjectActivities =
  createAsyncThunk(
    "OnePalestinianGovernoratesProjectActivities/ValidateOnePalestinianGovernoratesProjectActivities",
    async (PalestinianGovernoratesProjectActivities, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/TG_PalestinianGovernoratesProjectActivities/ValidatePalestinianGovernoratesProjectActivities",
          {
            tG_PalestinianGovernoratesNameId:
              PalestinianGovernoratesProjectActivities.tG_PalestinianGovernoratesNameId,
          }
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        if (response.data.success === true) {
          const arrayValidate = response.data.result.map((ele, ind) => {
            return ele.code;
          });
          return arrayValidate; // Return the extracted data
        }
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const OnePalestinianGovernoratesProjectActivities = createSlice({
  name: "OnePalestinianGovernoratesProjectActivities",
  initialState: {
    OnePalestinianGovernoratesProjectActivities: {},
    loadingOnePalestinianGovernoratesProjectActivities: false,
    errorOnePalestinianGovernoratesProjectActivities: null,

    ValidateOnePalestinianGovernoratesProjectActivities: [],
    loadingValidateOnePalestinianGovernoratesProjectActivities: false,
    errorValidateOnePalestinianGovernoratesProjectActivities: null,
  },
  reducers: {
    restValidationPalList: (state, action) => {
      state.ValidateOnePalestinianGovernoratesProjectActivities = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOnePalestinianGovernoratesProjectActivities.pending,
        (state, action) => {
          state.loadingOnePalestinianGovernoratesProjectActivities = true;
          state.OnePalestinianGovernoratesProjectActivities = action.payload;
          state.errorOnePalestinianGovernoratesProjectActivities = null;
        }
      )
      .addCase(
        GetOnePalestinianGovernoratesProjectActivities.fulfilled,
        (state, action) => {
          state.loadingOnePalestinianGovernoratesProjectActivities = false;
          state.OnePalestinianGovernoratesProjectActivities = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOnePalestinianGovernoratesProjectActivities.rejected,
        (state, action) => {
          state.loadingOnePalestinianGovernoratesProjectActivities = false;
          state.errorOnePalestinianGovernoratesProjectActivities =
            action.payload;
        }
      )

      .addCase(
        ValidateOnePalestinianGovernoratesProjectActivities.pending,
        (state, action) => {
          state.loadingValidateOnePalestinianGovernoratesProjectActivities = true;
          state.ValidateOnePalestinianGovernoratesProjectActivities =
            action.payload;
          state.errorValidateOnePalestinianGovernoratesProjectActivities = null;
        }
      )
      .addCase(
        ValidateOnePalestinianGovernoratesProjectActivities.fulfilled,
        (state, action) => {
          state.loadingValidateOnePalestinianGovernoratesProjectActivities = false;
          state.ValidateOnePalestinianGovernoratesProjectActivities =
            action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateOnePalestinianGovernoratesProjectActivities.rejected,
        (state, action) => {
          state.loadingValidateOnePalestinianGovernoratesProjectActivities = false;
          state.errorValidateOnePalestinianGovernoratesProjectActivities =
            action.payload;
        }
      );
  },
});
export const { restValidationPalList } = OnePalestinianGovernoratesProjectActivities.actions;
export default OnePalestinianGovernoratesProjectActivities.reducer;
